export class Line {
  public winName: string;
  public lineIndex: number;

  public positions: number[];
  public winAmount: number;
  public totalWin: number;
  public symbolId: number | null = null;
  public multiplier: number = 1;
}
